export const NATIONAL = 'National';
